var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgF45BLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 10,
    viewBox: "0 0 20 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 0H0V9.41598H4.67526V7.34844L8.48693 7.34856V9.76378H17.1479C18.7995 9.76378 19.9981 8.49431 19.9981 6.74524L20 0ZM17.1479 4.19076C17.9916 4.1913 18.4331 4.81585 18.4698 5.61243L18.4718 6.74642C18.4718 7.5639 18.0144 8.22917 17.1479 8.22917H12.3603V6.50725H16.8481V5.81391H11.6818H11.6584V8.22917H10.0133V5.81391H5.41086V5.81261H3.14885V7.88137H1.52637V1.53461H8.32714L5.70685 3.13969H3.14885V4.20875H5.31483L9.61376 1.53461H11.6438L11.6412 4.20875H12.3459V4.17346V1.53461H18.4736V3.13969H13.9999V4.19076H17.1479ZM8.00081 4.20875H9.99616L10.0133 2.89174L8.00081 4.20875ZM19.1632 3.833V0.841308H0.836771V8.57468H3.83849V6.50592H4.75515V6.50721H9.32374V8.92251H17.1479C18.3334 8.92251 19.1613 8.02766 19.1613 6.74524L19.1594 5.59586L19.1587 5.58043C19.123 4.8055 18.7966 4.18859 18.279 3.833H19.1632Z",
    fill: "#211551"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgF45BLogo);
export default __webpack_public_path__ + "static/media/f45b-logo.4dd87ceda6da27b1d8c4bc1400583308.svg";
export { ForwardRef as ReactComponent };